import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IExpOrg, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromExpOrg from './state/exp-org.selectors';
import * as ExpOrgAction from './state/exp-org.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';
// import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'exp-org-screen',
    templateUrl: 'exp-org.component.html',
    styleUrls: ['exp-org.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpOrgExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IExpOrg | null>;
    stateDataSubscription: Subscription;
    stateData: IExpOrg | null;

    getData: string = 'EXP_ORG';

    expOrgCCDetails = [];
    expOrgCIDetails = [];
    expOrgPPDetails = [];
    isNullExpOrgDetails: boolean = false;
    isLoadingExpOrgDetails: boolean = false;
    showErrorExpOrgDetails: boolean = false;
    errorMessageExpOrgDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['code', 'description'];
    // dataSource: MatTableDataSource<any>;


    constructor(
        private store: Store<fromExpOrg.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }

    ngOnInit() {
        this.startSubscriptions();
        this.getActiveExpOrgDataCC();
        // this.getActiveExpOrgDataCI();
        // this.getActiveExpOrgDataPFTP();
    }
    onTabChange(val) {
        if (val === 1 && this.expOrgCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveExpOrgDataCI();
        } else if (val === 2 && this.expOrgPPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveExpOrgDataPFTP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }
    getActiveExpOrgDataCC() {
        this.isLoadingExpOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expOrgCCDetails = data;
                        this.isLoadingExpOrgDetails = false;
                        // console.log('selected exp-org list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpOrgDetails = true;
                        this.errorMessageExpOrgDetails = 'There is not any selected exp-org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpOrgDetails = true;
                    this.errorMessageExpOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveExpOrgDataCI() {
        this.isLoadingExpOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expOrgCIDetails = data;
                        this.isLoadingExpOrgDetails = false;
                        // console.log('selected exp-org list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpOrgDetails = true;
                        this.errorMessageExpOrgDetails = 'There is not any selected exp-org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpOrgDetails = true;
                    this.errorMessageExpOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveExpOrgDataPFTP() {
        this.isLoadingExpOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expOrgPPDetails = data;
                        this.isLoadingExpOrgDetails = false;
                        // console.log('selected exp-org list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpOrgDetails = true;
                        this.errorMessageExpOrgDetails = 'There is not any selected exp-org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpOrgDetails = true;
                    this.errorMessageExpOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    editExpOrgListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    // console.log('exp-org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Org (CC)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-org CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpOrgDataCC();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }


    editExpOrgListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    // console.log('exp-org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Org (CI)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-org CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpOrgDataCI();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editExpOrgListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    // console.log('exp-org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Org (PFTP)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-org PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpOrgDataPFTP();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromExpOrg.getExpOrgScreenPending);
        this.stateData$ = this.store.select(fromExpOrg.getExpOrgState);
        this.error$ = this.store.select(fromExpOrg.getExpOrgScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new ExpOrgAction.ExpOrgScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}
